import {useLazyQuery} from '@apollo/client';
import {
  GET_GENERIC_HISTORY_DIFF,
  GET_STAFF_HISTORY_DIFF,
  GET_GROUP_CHANGE_HISTORY,
} from './accountReviewDialogQueries';
import {HistoryDiffDetails} from '../../schema-types/HistoryDiffDetails';

export enum HistoryQueryType {
  GENERIC = 'GENERIC',
  STAFF = 'STAFF',
  GROUP = 'GROUP',
}

interface QueryResult {
  genericHistoryDiff?: HistoryDiffDetails[];
  staffHistoryDiff?: HistoryDiffDetails[];
  groupChangeHistory?: HistoryDiffDetails[];
}

export function useHistoryDiff(queryType: HistoryQueryType) {
  let query;
  switch (queryType) {
    case HistoryQueryType.GENERIC:
      query = GET_GENERIC_HISTORY_DIFF;
      break;
    case HistoryQueryType.STAFF:
      query = GET_STAFF_HISTORY_DIFF;
      break;
    case HistoryQueryType.GROUP:
      query = GET_GROUP_CHANGE_HISTORY;
      break;
    default:
      throw new Error('Unsupported query type');
  }

  const [onGetHistoryDiff, {loading, error, data}] = useLazyQuery<QueryResult>(query, {
    fetchPolicy: 'no-cache', // no-cache fetch policy requested by back-end dev team
  });

  const getData = () => {
    switch (queryType) {
      case HistoryQueryType.GENERIC:
        return data?.genericHistoryDiff;
      case HistoryQueryType.STAFF:
        return data?.staffHistoryDiff;
      case HistoryQueryType.GROUP:
        return data?.groupChangeHistory;
      default:
        return undefined;
    }
  };

  return {
    loading,
    error,
    data: getData(),
    onGetHistoryDiff,
  };
}
